const firebaseConfig = {
  apiKey: "AIzaSyAcN64p-HEOjQOLndAAq5bFcY3b3yBGSB4",
  authDomain: "airlines-dba70.firebaseapp.com",
  projectId: "airlines-dba70",
  storageBucket: "airlines-dba70.appspot.com",
  messagingSenderId: "164645439615",
  appId: "1:164645439615:web:14139d5099908d1769174a"
  };

  export default firebaseConfig;





//   // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyAcN64p-HEOjQOLndAAq5bFcY3b3yBGSB4",
//   authDomain: "airlines-dba70.firebaseapp.com",
//   projectId: "airlines-dba70",
//   storageBucket: "airlines-dba70.appspot.com",
//   messagingSenderId: "164645439615",
//   appId: "1:164645439615:web:14139d5099908d1769174a"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);